import type { SearchHit } from '@tf/shared';
import { Box, Button, createStyles, Flex, Group, Icon, TFText } from '@tf/ui';
import { saveFile } from '@tf/utils';
import type React from 'react';
import { useState } from 'react';

import { useDownloadMonitoringSearchCertificateMutation } from '../../../../../api/monitoringSearchCertificate';

import { JobResultTable } from './index';
import type { Matches } from './JobResultTable';

const useStyles = createStyles(({ colors }) => ({
	footer: {
		position: 'absolute',
		backgroundColor: 'white',
		width: '100%',
		padding: '0.75rem 1rem',
		bottom: '0',
		height: '4rem',
		borderTop: `1px solid ${colors.gray[2]}`,
	},
	table: {
		marginBottom: '4rem',
	},
}));

interface Props {
	hits: SearchHit[] | null;
	searchId?: number;
	searchName: string;
	onSaveMatches: (matches: Matches) => void;
}

export const JobResultTableContainer: React.FC<Props> = ({ hits, searchName, onSaveMatches, searchId }) => {
	const { classes } = useStyles();

	const [matches, setMatches] = useState<Matches>({ ids: [], comments: [] });

	const downloadCertificateMutation = useDownloadMonitoringSearchCertificateMutation();

	if (!hits) return null;

	return (
		<>
			<Box p="1rem" className={classes.table}>
				<JobResultTable hits={hits} matches={matches} onUpdateMatches={setMatches} />
			</Box>
			<Group justify="space-between" className={classes.footer} gap="sm">
				<TFText fw="500">
					{hits.length || 0} possible matches
					{matches.ids.length === 0 ? ', none of them are positive matches' : `, ${matches.ids.length} selected`}
				</TFText>
				<Flex justify="space-between" gap="8px">
					<Button
						variant="light"
						leftSection={<Icon.IconFileDownload size={14} stroke={2.5} />}
						disabled={downloadCertificateMutation.isPending}
						onClick={async () => {
							if (!searchId) return;
							const res = await downloadCertificateMutation.mutateAsync(`${searchId}`);
							saveFile(res, `${searchName || 'background check'}.pdf`);
						}}
					>
						Download search certificate
					</Button>
					<Button
						miw="125px"
						onClick={() => {
							onSaveMatches(matches);
						}}
					>
						Submit
					</Button>
				</Flex>
			</Group>
		</>
	);
};
